// The one story the public site repeats: one invoice through four console
// screens, then the two products that story leads to. The homepage runs
// it (SpineRun), /platform reads it back by module, /app-kit and /platform
// hand off to each other with the same two sentences. Content lives here so
// the three pages cannot drift ([[website-product-first-messaging]],
// continuity pass 2026-10-22).

// Govern, on one invoice. Labels match the four console screens SpineRun
// draws (canvas, Human Review, receipt, Command View). `module` is the
// name /platform reads the step back under; `moduleTo` where that differs
// from the homepage link (Record points at the fleet on the homepage, at
// Athena on /platform).
export const INVOICE = [
  { n: '01', k: 'Read', what: 'In nQube the workflow reads each invoice: vendor, amount, terms. The agents do the steps; one block is the write.', to: '/platform/nqube', cta: 'nQube', module: 'nQube' },
  { n: '02', k: 'Hold', what: 'Anything over policy waits for a person, or a keyword rule holds it. A yes does not hand the model a pen. It lets the runtime post.', to: '/gate', cta: 'What a gate is', module: 'What a gate is' },
  { n: '03', k: 'Post', what: 'Only the runtime posts to your ERP, with its own credentials, and leaves the receipt: who approved, when, a hash of what was written. A retry cannot post twice.', to: '/platform/agentos', cta: 'agentOS', module: 'agentOS' },
  { n: '04', k: 'Record', what: 'Every run is on the record. On App Kit the fleet also restarts a down service and rolls back a deploy that fails its check.', to: '/app-kit', cta: 'The fleet', module: 'Athena · DevOps', moduleTo: '/platform/athena' },
];

// The two products, as the homepage introduces them before the price
// cards. `parts` are names a visitor will meet again on the product page;
// `measure` picks the trust-band number that belongs to each.
export const PRODUCTS = [
  {
    id: 'platform',
    name: 'Platform',
    to: '/platform',
    how: 'How Platform works',
    lead: 'What you just watched. Design the workflow in nQube, put a person or a rule at the gate, and agentOS posts to the systems you already use.',
    parts: ['nQube', 'agentOS', 'Agent IO', 'nventr Agent', 'Knowledge', 'Integrations', 'Human Review', 'Athena', 'Listen', 'DevOps'],
    measure: 'cost',
  },
  {
    id: 'kit',
    name: 'App Kit',
    to: '/app-kit',
    how: 'How App Kit works',
    lead: 'The app for building apps. Your URL, database and layer repo on a foundation we keep running; Dev Console to change it; the same nQube inside.',
    parts: ['Dev Console', 'Your layer repo', 'UAT twin', 'MCP server', 'Health-gated deploys', 'The fleet'],
    measure: 'claim',
  },
];

// The hand-off between the two product pages: the same two sentences on
// /platform#app-kit and /app-kit, pointing at each other.
export const HANDOFF = {
  line: 'One runtime under both. nQube designs the workflow on Platform and inside an App Kit app; agentOS commits it either way.',
  platform: { k: 'Platform', v: 'Writes to the systems you already use — your ERP, CRM, ticketing — with a person or a rule at the gate. No app to host.', to: '/platform', cta: 'How Platform works' },
  kit: { k: 'App Kit', v: 'The app your users sign into — your URL, database and layer repo. Dev Console included. The fleet keeps it up.', to: '/app-kit', cta: 'How App Kit works' },
};
